import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Form,
  Tooltip,
  Input,
  Popconfirm,
  Upload,
  Select,
  List,
} from "antd";
import {
  UnorderedListOutlined,
  EditFilled,
  DeleteFilled,
  ToolFilled,
} from "@ant-design/icons";
import { convertColumns } from "../../../../utils/columnconverter";
import { notify } from "../../../../redux/actions";
import { connect } from "react-redux";
import aictia from "../../../../const/api";
import { useTranslation } from "react-i18next";
import { whiteSpace, noWhitespace } from "../../../../utils/rules";
import axios from "axios";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
const Types = (props) => {

  const [form] = Form.useForm();
  const { t } = useTranslation();

  const [positions, setPositions] = useState([]);
  const [spin, setSpin] = useState(false);
  const [editing, setEditing] = useState(null);
  const [reset, setReset] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState("TypeOfProject");
  const cols = [
    { key: "index", value: "#", con: true },
    { key: "name", value: t("name"), con: true },
    { key: "id", value: "", con: false },
  ];
  const nameInput = useRef();
  const { notify } = props;



  const { Option } = Select;
  const columns = [
    {
      title: "#",
      key: "1",
      dataIndex: "index",
      width: 80,
    },
    {
      title: t("name"),
      key: "2",
      dataIndex: "name",
    },
    {
      title: "",
      key: "3",
      dataIndex: "id",
      width: 30,
      render: (i) => {
        return (
          <div className="flex flex-end">
            <Popconfirm
              placement="topRight"
              title={t("areYouSure")}
              onConfirm={() => deletePosition(i)}
              okText={t("yes")}
              cancelText={t("no")}
            >
              <Tooltip className="ml-5" title={t("delete")}>
                <Button className="border-none" type="text" shape="circle">
                  <DeleteFilled />
                </Button>
              </Tooltip>
            </Popconfirm>
            <Tooltip className="ml-5" title={t("edit")} placement="topRight">
              <Button
                className="border-none"
                type="text"
                shape="circle"
                onClick={() => setEditingObject(i)}
              >
                <EditFilled />
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const setEditingObject = async (i) => {
    setEditing(i);
    await aictia.get(selectedCategory + `/${i}`).then((res) => {
      const name = res.data.name
      let obj = {};
      obj[`name`] = name;
      form.setFieldsValue(obj);
    });
  };

  const cancelEditing = () => {
    setEditing(null);
    form.resetFields();
  };

  const deletePosition = async (i) => {
    await aictia
      .delete(`${selectedCategory}/${i}`)
      .then(() => {
        // description
        notify("silindi", true);
        getPositions();
      })
      .catch((err) => {
        //error
        notify(err.response, false);
      });
  };

  const savePosition = async (values) => {
    if (!editing) {
      await aictia
        .post(selectedCategory, values)
        .then((res) => {
          notify("", true);
          getPositions();
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    } else {
      await aictia
        .put(`${selectedCategory}/${editing}`, { id: editing, name: values.name })
        .then((res) => {
          notify("", true);
          getPositions();
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    }
  };

  const getPositions = async () => {
    setSpin(true);
    await aictia.get(selectedCategory).then((res) => {
      setSpin(false);
      setPositions(
        res.data.map((p, index) => {
          return {
            key: index + 1,
            ...p,
            index: index + 1,
          };
        })
      );
    });
  };
  useEffect(() => {
    getPositions();
  }, [selectedCategory]);

  return (
    <Row gutter={[10, 10]} className="pl-1" >
      <Col xs={24}>
        <div className="border flex animated fadeInDown p-2 mt-0 bg-white" style={{ borderRadius: '20px' }}>
          <span
            style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              background: "#eff6ff",
              color: "#0c82f4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 10,
              marginTop: 5,
            }}
          >
            <UnorderedListOutlined className="f-20" />
          </span>
          <div>
            <span className="f-20 bold">{t('types')}</span>
            <p className="text-[11px] text-slate-450 font-medium">{t("typesSub")}</p>
          </div>
        </div>
      </Col>

      <Col xs={12}>
        <div className="ant-card ant-card-bordered ant-card-shadow" style={{
          border: "1px solid rgba(226,232,240,.85)",
          borderRadius: 16,
          overflow: "hidden",
          boxShadow: "0 1px 2px rgba(15,23,42,.04)"
        }}>
          {/* HEADER */}
          <div
            style={{
              borderBottom: "1px solid #f0f0f0",
              padding: "12px 16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
            }}
          >
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, textTransform: "uppercase" }}>
                Növlər (Kateqoriya bölməsi)
              </div>
              <div style={{ fontSize: 10, color: "#999", fontWeight: 600 }}>
                PORTFEL ELEMENTLƏRİNİN TIP LISTI
              </div>
            </div>

            {/* SELECT (Ant Design style saxlanılıb) */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "4px 10px",
                background: "#f8fafc",
                border: "1px solid rgba(226,232,240,.9)",
                borderRadius: 12,
              }}
            >
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 900,
                  color: "#475569",
                  textTransform: "uppercase",
                  letterSpacing: "0.6px",
                }}
              >
                Kateqoriya:
              </span>

              <Select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e)}
                size="small"
                bordered={false}
                style={{
                  minWidth: 160,
                  background: "transparent",
                }}
                dropdownStyle={{
                  borderRadius: 12,
                }}
              >
                <Option value={"TypeOfProject"}>Layihə</Option>
                <Option value={"TypeOfStartup"}>Startup</Option>
                <Option value={"TypeOfInnovation"}>İnnovasiya</Option>
                <Option value={"TypeOfInvention"}>İxtira</Option>
                <Option value={"TypeOfProduct"}>Məhsul</Option>
              </Select>
            </div>
          </div>

          {/* TABLE BODY */}
          <div
            style={{
              padding: 12,
              background: "#fff",
            }}
          >
            <List
              loading={spin}
              grid={{
                gutter: 12,
                xs: 1,
                sm: 1,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              dataSource={convertColumns(positions, cols)}
              locale={{ emptyText: "Siyahı boşdur." }}
              renderItem={(item, index) => (
                <List.Item style={{ border: "none", padding: 0 }}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      background: "#f8fafc",
                      border: "1px solid rgba(226,232,240,.9)",
                      borderRadius: 12,
                      padding: "10px 14px",
                      transition: "all .15s ease",
                    }}
                    className="hover:shadow-sm hover:bg-slate-100"
                  >
                    {/* INDEX */}
                    <div
                      style={{
                        width: 50,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          minWidth: 22,
                          height: 22,
                          padding: "0 6px",
                          background: "#fff",
                          border: "1px solid #cfd6df",
                          borderRadius: 6,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 11,
                          fontWeight: 700,
                          fontFamily: "monospace",
                          color: "#111",
                        }}
                      >
                        {index + 1}
                      </span>
                    </div>

                    <div
                      style={{
                        flex: 1,
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#111827",
                      }}
                    >
                      {item.name}
                    </div>

                    {/* ACTIONS */}
                    <div
                      style={{
                        width: 90,
                        display: "flex",
                        justifyContent: "center",
                        gap: 10,
                      }}
                    >
                      <EditFilled
                        onClick={() => setEditingObject(item)}
                        style={{
                          fontSize: 15,
                          color: "#64748b",
                          cursor: "pointer",
                        }}
                      />

                      <DeleteFilled
                        onClick={() => deletePosition(item.id)}
                        style={{
                          fontSize: 15,
                          color: "#64748b",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </div>
                </List.Item>
              )}
            />
          </div>
        </div>
      </Col>

      <Col lg={12} xs={24}>
        <Card title={"Əlavə et"} className={"animated fadeInRight administrator"} style={{ borderRadius: '20px' }}>
          <Form layout="vertical" onFinish={savePosition} form={form}>
            <div className="form-lang mb-20">
              <FloatLabel>
                <Form.Item
                  className="mb-5"
                  validateTrigger="onChange"
                  name="name"
                  rules={[whiteSpace(t("inputError"))]}
                >
                  <InputText ref={nameInput} className="w-full" id="name" style={{ borderRadius: '12px' }} />

                </Form.Item>
                <label htmlFor="name">{t(selectedCategory)}</label>
              </FloatLabel>
            </div>
            <div className="flex flex-between mt-15">
              <Button
                onClick={cancelEditing}
                style={{
                  height: 36,
                  padding: "0 16px",
                  borderRadius: 10,
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#334155",
                  marginRight: 10,
                }}
              >
                {t("cancel")}
              </Button>

              <Button
                htmlType="submit"
                style={{
                  height: 36,
                  padding: "0 16px",
                  borderRadius: 10,
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#334155",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {t("save")}
              </Button>
            </div>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ langs }) => {
  return {
    langs: langs,
  };
};

export default connect(mapStateToProps, { notify })(Types);
